import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import LocalMapLayerImg from './img/LocalMapLayer.png'

export default class LocalMapLayer extends Component {
  render() {
    return (
      <div className="main-window">
      <div className="main-window-title">使用本地图层功能</div>
      <img src={LocalMapLayerImg} className="main-window-img"></img>
    </div>
    )
  }
}
